import { StarIcon } from 'lucide-react'

import {
  useFilterTransactionsByFavorites,
  useProjectActions,
} from '@/modules/projects/hooks'
import { cn } from '@/utils'

export const FavoriteHeader = () => {
  const isActive = useFilterTransactionsByFavorites()
  const { setFilterByFavorites } = useProjectActions()

  return (
    <button
      type="button"
      onClick={() => setFilterByFavorites(!isActive)}
      className={cn(
        'hover:bg-neutral-100 p-1 rounded transition-colors cursor-pointer',
        isActive && 'bg-yellow-50',
      )}
      aria-label={isActive ? 'Show all transactions' : 'Show only favorites'}
    >
      <StarIcon
        className={cn(
          'h-4 w-4 transition-colors',
          isActive ? 'fill-yellow-500 text-yellow-500' : 'text-neutral-400',
        )}
      />
    </button>
  )
}
